import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-diagnosis-lymphadenopathy-dialog',
  templateUrl: './diagnosis-lymphadenopathy-dialog.component.html',
  styleUrls: ['./diagnosis-lymphadenopathy-dialog.component.scss']
})
export class DiagnosisLymphadenopathyDialogComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<DiagnosisLymphadenopathyDialogComponent>) { }

  ngOnInit(): void {
  }

  onOkClick() {
    this.dialogRef.close();
  }
}
